import Swiper from 'swiper';
import {Navigation, Virtual, A11y, Pagination} from 'swiper/modules';
import 'swiper/css';

const defaultOptions = {
    modules: [Navigation, Virtual, A11y, Pagination],
    direction: 'horizontal',
    spaceBetween: 8,
    slidesPerView: 1.2,
    centerInsufficientSlides: true,
    breakpoints: {
        768: {
            slidesPerView: 2.1,
        },
        1400: {
            slidesPerView: 3.1,
        },
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    a11y: {
        prevSlideMessage: 'Forrige slide',
        nextSlideMessage: 'Næste slide',
    },
};

document.querySelectorAll('.swiper').forEach(function (el) {
    const swiper = new Swiper(el, defaultOptions);

    function updateControls() {
        const slideCount = el.querySelectorAll('.swiper-slide').length;

        let slidesPerView = swiper.params.slidesPerView;

        if (typeof slidesPerView === 'string' && slidesPerView === 'auto') {
            slidesPerView = swiper.slidesPerViewDynamic();
        } else if (typeof slidesPerView !== 'number') {
            slidesPerView = 1;
        }

        slidesPerView = Math.floor(slidesPerView);

        const shouldEnable = slideCount > slidesPerView;

        const container = el.closest('.cards-component') || el;

        container.classList.toggle('no-swiper-controls', !shouldEnable);
    }

    updateControls();

    window.addEventListener('resize', updateControls);
    swiper.on('breakpoint', updateControls);
});